import React from 'react';
import { FileIcon } from 'elements/Icon';

const PPT = () => (
  <FileIcon>
    <path d="M98,2v136H2V2H98 M100,0H0v140h100V0L100,0z"/>
    <rect x="13.23" y="103.718" width="74" height="24"/>
    <g>
      <g>
        <line fill="none" stroke="#000000" strokeWidth="1.4173" strokeMiterlimit="10" x1="49.75" y1="72" x2="49.75" y2="82.286"/>
      </g>
      <line fill="none" stroke="#000000" strokeWidth="1.4173" strokeMiterlimit="10" x1="49.75" y1="81" x2="42.679" y2="88.071"/>
      <line fill="none" stroke="#000000" strokeWidth="1.4173" strokeMiterlimit="10" x1="49.75" y1="81" x2="56.821" y2="88.071"/>
      <path d="M74.928,46.822v24.641H24.572V46.822H74.928 M76.75,45h-54v28.286h54V45L76.75,45z"/>
      <g>
        <polyline fill="none" stroke="#000000" strokeWidth="1.4173" strokeMiterlimit="10" points="29.179,64.929 38.179,56.571 
          48.464,63.643 54.893,53.357 61.321,61.714 68.244,53.31 		"/>
        <polygon points="69.574,55.266 70.321,50.786 66.067,52.379 		"/>
      </g>
    </g>
    <g>
      <path fill="#FFFFFF" className="text" d="M33.042,119.14h2.367v2.336h-2.367V119.14z"/>
      <path fill="#FFFFFF" className="text" d="M45.437,116.492c-0.674,0.562-1.637,0.844-2.888,0.844h-2.397v4.141h-2.391V109.96h4.944
        c1.14,0,2.049,0.297,2.727,0.891s1.017,1.513,1.017,2.758C46.448,114.968,46.112,115.929,45.437,116.492z M43.601,112.343
        c-0.305-0.255-0.731-0.383-1.281-0.383h-2.168v3.391h2.168c0.55,0,0.977-0.138,1.281-0.414s0.457-0.714,0.457-1.312
        S43.906,112.598,43.601,112.343z"/>
      <path fill="#FFFFFF" className="text" d="M56.109,116.492c-0.674,0.562-1.637,0.844-2.888,0.844h-2.397v4.141h-2.391V109.96h4.944
        c1.14,0,2.049,0.297,2.727,0.891s1.017,1.513,1.017,2.758C57.12,114.968,56.783,115.929,56.109,116.492z M54.273,112.343
        c-0.305-0.255-0.731-0.383-1.281-0.383h-2.168v3.391h2.168c0.55,0,0.977-0.138,1.281-0.414s0.457-0.714,0.457-1.312
        S54.577,112.598,54.273,112.343z"/>
      <path fill="#FFFFFF" className="text" d="M67.417,109.96v2.039h-3.445v9.477H61.55v-9.477h-3.461v-2.039H67.417z"/>
    </g>
  </FileIcon>
);

export default PPT;



// WEBPACK FOOTER //
// ./src/core/icons/components/files/PPT.jsx